import { teams, ICareerTeam } from '../../../content/career/cards';
import * as React from 'react';
import { cx } from '../../../components/CareerLayout/styles';
import * as media from '../../../assets/career/media';

const TeamCard: React.FC<{ team: ICareerTeam; layout: string }> = ({ team, layout }) => (
  <article className={cx('main_team_card ' + layout)}>
    <div className={cx('tag ' + team.tagStyle)}>{team.quote}</div>
    <div className={cx('main_team_card-bottom')}>
      <h3 className={cx('text-style-uppercase multiline')}>{team.title}</h3>
      <button type="button" className={cx('button is-green max-width-full')}>
        Подробнее
      </button>
    </div>
  </article>
);

export const Teams: React.FC = () => (
  <section id="teams" className={cx('main_section_team')}>
    <div className={cx('padding-global padding-section-large')}>
      <div className={cx('container-large')}>
        <div className={cx('main_content_team')}>
          <div className={cx('main_team_h2-wrapper')}>
            <img
              src={media.mainTeamMouseImage}
              loading="lazy"
              sizes="100vw"
              srcSet={[
                media.mainTeamMouseImageP500 + ' 500w',
                media.mainTeamMouseImageP800 + ' 800w',
                media.mainTeamMouseImageP1080 + ' 1080w',
                media.mainTeamMouseImage + ' 1503w',
              ].join(', ')}
              alt=""
              className={cx('main_team_mouse-image')}
            />
            <h2 className={cx('z-index-2')}>
              <span className={cx('text-color-brand-green')}>{'Команда,'}</span>
              {' которой '}
              <br />
              {'не всё равно'}
            </h2>
            <div className={cx('spacer-large')}></div>
            <div className={cx('text-size-large')}>
              {'Больше тысячи человек, которым важно, что они делают и зачем.'}
            </div>
          </div>
          <div className={cx('spacer-large')}></div>
          <div className={cx('main_team_card-grid')}>
            <TeamCard team={teams[0]} layout="layout11" />
            <img
              src={media.mainTeamDuckImage}
              loading="lazy"
              sizes="100vw"
              alt=""
              srcSet={[media.mainTeamDuckImageP500 + ' 500w', media.mainTeamDuckImage + ' 570w'].join(', ')}
              className={cx('main_team_duck-image layout12')}
            />
            <TeamCard team={teams[1]} layout="layout13" />
            <img
              src={media.mainTeamHeartImage}
              loading="lazy"
              sizes="100vw"
              alt=""
              srcSet={[media.mainTeamHeartImageP500 + ' 500w', media.mainTeamHeartImage + ' 761w'].join(', ')}
              className={cx('main_team_heart-image layout14')}
            />
            <TeamCard team={teams[2]} layout="layout15" />
            <TeamCard team={teams[3]} layout="layout16" />
            <div className={cx('main_team_images-wrapper layout17')}>
              <img src={media.mainTeamStarImage} loading="lazy" alt="" className={cx('main_team_star-image')} />
              <img
                src={media.mainTeamSmileImage}
                loading="lazy"
                sizes="100vw"
                srcSet={[media.mainTeamSmileImageP500 + ' 500w', media.mainTeamSmileImage + ' 657w'].join(', ')}
                alt=""
                className={cx('main_team_smile-image')}
              />
            </div>
            <TeamCard team={teams[4]} layout="layout18" />
            <img
              src={media.mainTeamMobileMouseImage}
              loading="lazy"
              alt=""
              className={cx('main_team_mobile-mouse-image layout19')}
            />
          </div>
        </div>
      </div>
    </div>
  </section>
);
